export type VideoType = 'movie' | 'tv' | 'apple';

export interface Video {
  id: string;
  title: string;
  type: VideoType;
  appleCategory?: string;
  cover: string;
  duration: string;
  year: string;
  region: string;
  genres: string[];
  tags: string[];
  shortDesc: string;
  synopsis: string;
  uploadDate: string;
  views: string;
  rating: number;
}

export const videos: Video[] = [
  {
    id: 'mv001',
    title: '星际迷航：新纪元',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20scene%20deep%20space%20starship%20nebula%20blue%20and%20orange%20glow%2C%20high%20contrast%20dramatic%20lighting%2C%20premium%20film%20key%20art%2C%20no%20text&width=800&height=450&seq=mv001cover&orientation=landscape',
    duration: '02:18:40',
    year: '2026',
    region: '美国',
    genres: ['科幻', '冒险'],
    tags: ['太空', '未来', '史诗'],
    shortDesc: '人类首次穿越虫洞，探索未知星系，一场关于文明存续的远征就此展开。',
    synopsis:
      '在不远的未来，地球资源枯竭，一支由顶尖科学家与宇航员组成的远征队驾驶“晨星号”穿越人工虫洞，抵达遥远的开普勒星系。他们不仅要面对陌生的宇宙环境，还要在信任与背叛之间做出抉择。影片以宏大的宇宙视效与细腻的人物刻画，讲述人类在绝境中寻找新家园的故事。',
    uploadDate: '2026-09-28',
    views: '128.6万',
    rating: 9.1,
  },
  {
    id: 'mv002',
    title: '山海之城',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20movie%20key%20art%20ancient%20chinese%20mountain%20city%20floating%20in%20mist%20with%20golden%20sunlight%20and%20epic%20clouds%2C%20premium%20film%20poster%20style%2C%20dramatic%20atmosphere%2C%20no%20text&width=800&height=450&seq=mv002cover&orientation=landscape',
    duration: '02:05:12',
    year: '2025',
    region: '中国大陆',
    genres: ['奇幻', '古装'],
    tags: ['神话', '特效', '东方美学'],
    shortDesc: '少年误入山海秘境，为守护古城与神兽并肩而战。',
    synopsis:
      '传说在山与海交汇之处，藏着一座被云雾笼罩的古城。少年阿澈在祖父遗留的古卷指引下误入秘境，遇见了守护城池的神兽白泽。当远古的灾厄再度苏醒，阿澈必须学会驾驭神秘的力量，与伙伴们一同抵抗黑暗，守护这座承载千年记忆的城市。',
    uploadDate: '2025-12-15',
    views: '96.2万',
    rating: 8.6,
  },
  {
    id: 'mv003',
    title: '沉默的证人',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=moody%20crime%20thriller%20movie%20poster%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%20and%20lone%20silhouette%2C%20cinematic%20teal%20and%20amber%20lighting%2C%20suspenseful%20atmosphere%2C%20no%20text&width=800&height=450&seq=mv003cover&orientation=landscape',
    duration: '01:52:30',
    year: '2025',
    region: '中国香港',
    genres: ['悬疑', '犯罪'],
    tags: ['推理', '法庭', '反转'],
    shortDesc: '一桩尘封旧案，唯一的证人却始终保持沉默。',
    synopsis:
      '资深法医在整理旧案卷宗时，发现多年前的一宗命案存在关键疑点。唯一的目击者是一名失去语言能力的孩子。随着调查深入，真相层层剥开，隐藏在沉默背后的，是一个关于良知与救赎的故事。影片节奏紧凑，悬念迭起，直到最后一刻才揭晓谜底。',
    uploadDate: '2025-11-08',
    views: '74.8万',
    rating: 8.9,
  },
  {
    id: 'mv004',
    title: '春风十里',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20romantic%20film%20poster%20spring%20countryside%20road%20lined%20with%20blooming%20cherry%20blossoms%20soft%20golden%20hour%20light%2C%20gentle%20cinematic%20tone%2C%20hopeful%20mood%2C%20no%20text&width=800&height=450&seq=mv004cover&orientation=landscape',
    duration: '01:46:20',
    year: '2026',
    region: '中国大陆',
    genres: ['爱情', '剧情'],
    tags: ['青春', '治愈', '成长'],
    shortDesc: '两个在城市中奔波的年轻人，在一场春雨里重新找回初心。',
    synopsis:
      '建筑师林知与插画师苏晚在一次雨天相遇，两人因一场城市改造项目而结缘。理想与现实的压力接踵而至，他们在误解与坚持中学会理解彼此。影片以清新细腻的镜头语言，讲述一段关于梦想、陪伴与成长的温暖故事。',
    uploadDate: '2026-08-20',
    views: '88.4万',
    rating: 8.2,
  },
  {
    id: 'mv005',
    title: '极速追击',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=high%20octane%20action%20movie%20poster%20sports%20car%20speeding%20through%20neon%20city%20tunnel%20with%20motion%20blur%20and%20orange%20light%20streaks%2C%20dynamic%20cinematic%20composition%2C%20intense%20energy%2C%20no%20text&width=800&height=450&seq=mv005cover&orientation=landscape',
    duration: '01:58:45',
    year: '2025',
    region: '美国',
    genres: ['动作', '赛车'],
    tags: ['飙车', '刺激', '高燃'],
    shortDesc: '一名退役车手被迫重返赛道，用一场生死竞速换回家人平安。',
    synopsis:
      '曾经的顶级车手因一场事故告别赛场，隐姓埋名过着平凡生活。当家人被卷入一桩跨国阴谋，他不得不再次握紧方向盘，在午夜的街道上展开一场惊心动魄的追逐。影片以实拍特技与高速镜头，带来肾上腺素飙升的观影体验。',
    uploadDate: '2025-10-30',
    views: '112.3万',
    rating: 8.5,
  },
  {
    id: 'mv006',
    title: '时光信笺',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=nostalgic%20drama%20film%20poster%20old%20wooden%20desk%20with%20stack%20of%20handwritten%20letters%20and%20vintage%20lamp%20warm%20soft%20light%2C%20emotional%20cinematic%20tone%2C%20quiet%20melancholy%20atmosphere%2C%20no%20text&width=800&height=450&seq=mv006cover&orientation=landscape',
    duration: '02:01:18',
    year: '2026',
    region: '中国大陆',
    genres: ['剧情', '文艺'],
    tags: ['时间', '亲情', '治愈'],
    shortDesc: '一封迟到了二十年的信，揭开了一个家庭深藏的秘密。',
    synopsis:
      '整理老宅时，女儿意外发现母亲年轻时写下却从未寄出的信。通过一封封信笺，她逐渐拼凑出父母那代人的青春与遗憾。影片探讨了时间、记忆与和解，用克制的叙事打动人心。',
    uploadDate: '2026-07-12',
    views: '63.7万',
    rating: 8.8,
  },
  {
    id: 'mv007',
    title: '边境线',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=gritty%20crime%20drama%20movie%20poster%20snowy%20border%20mountain%20road%20with%20lone%20truck%20and%20cold%20blue%20dawn%20light%2C%20tense%20minimalist%20cinematic%20composition%2C%20harsh%20landscape%2C%20no%20text&width=800&height=450&seq=mv007cover&orientation=landscape',
    duration: '01:49:05',
    year: '2025',
    region: '中国大陆',
    genres: ['犯罪', '剧情'],
    tags: ['缉毒', '边防', '写实'],
    shortDesc: '在零下三十度的边境线上，一场看不见硝烟的较量悄然展开。',
    synopsis:
      '边防缉毒队员常年驻守在荒无人烟的边境线上。一次看似普通的例行检查，牵出一条隐藏多年的走私链条。影片以冷峻写实的风格，致敬默默守护国门的无名英雄。',
    uploadDate: '2025-09-18',
    views: '58.9万',
    rating: 8.4,
  },
  {
    id: 'mv008',
    title: '深海之光',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=underwater%20adventure%20film%20poster%20deep%20ocean%20with%20bioluminescent%20glowing%20creatures%20and%20light%20rays%20from%20surface%2C%20mysterious%20cinematic%20blue%20teal%20palette%2C%20awe%20inspiring%2C%20no%20text&width=800&height=450&seq=mv008cover&orientation=landscape',
    duration: '01:55:40',
    year: '2026',
    region: '法国',
    genres: ['冒险', '科幻'],
    tags: ['海洋', '探索', '视觉'],
    shortDesc: '深潜至万米海底，他们发现了从未被记录的生命之光。',
    synopsis:
      '一支海洋科考队深入马里亚纳海沟执行探测任务，意外发现了一片闪烁着幽蓝光芒的生态系统。面对未知的深海环境与设备故障，队员们在生存与发现之间做出艰难选择。影片以震撼的水下摄影，呈现海洋的神秘与壮美。',
    uploadDate: '2026-06-05',
    views: '81.2万',
    rating: 8.7,
  },
  {
    id: 'tv001',
    title: '长安十二时',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=epic%20historical%20chinese%20drama%20poster%20ancient%20city%20lanterns%20at%20dusk%20with%20palace%20silhouette%20and%20warm%20golden%20haze%2C%20grand%20cinematic%20production%20design%2C%20elegant%20atmosphere%2C%20no%20text&width=800&height=450&seq=tv001cover&orientation=landscape',
    duration: '45:20',
    year: '2026',
    region: '中国大陆',
    genres: ['古装', '悬疑'],
    tags: ['权谋', '盛唐', '群像'],
    shortDesc: '十二时辰之内，一场关乎整座城池安危的谜局亟待破解。',
    synopsis:
      '上元灯节前夕，长安城内暗流涌动。一名身陷囹圄的死囚被临时启用，须在十二个时辰之内找出潜藏的危机源头。剧集以精良的服化道与紧凑的叙事，还原盛世之下的暗涌。',
    uploadDate: '2026-09-10',
    views: '203.5万',
    rating: 9.2,
  },
  {
    id: 'tv002',
    title: '都市迷航',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%20night%20cityscape%20with%20rain%20and%20glass%20office%20towers%20reflecting%20cool%20lights%2C%20moody%20cinematic%20tone%2C%20contemporary%20atmosphere%2C%20no%20text&width=800&height=450&seq=tv002cover&orientation=landscape',
    duration: '42:15',
    year: '2025',
    region: '中国大陆',
    genres: ['都市', '剧情'],
    tags: ['职场', '现实', '成长'],
    shortDesc: '三个年轻人在大城市的霓虹里寻找属于自己的方向。',
    synopsis:
      '来自不同背景的三位年轻人因缘际会合租在同一屋檐下。面对职场的压力、生活的琐碎与情感的选择，他们彼此扶持，也在迷茫中逐渐认清自我。剧集真实呈现当代都市青年的生存图景。',
    uploadDate: '2025-11-22',
    views: '156.8万',
    rating: 8.5,
  },
  {
    id: 'tv003',
    title: '暗夜追踪',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=dark%20mystery%20crime%20series%20poster%20foggy%20alley%20at%20midnight%20with%20single%20street%20lamp%20and%20long%20shadow%2C%20tense%20noir%20cinematic%20mood%2C%20suspenseful%20mood%2C%20no%20text&width=800&height=450&seq=tv003cover&orientation=landscape',
    duration: '48:05',
    year: '2026',
    region: '中国大陆',
    genres: ['悬疑', '刑侦'],
    tags: ['追凶', '烧脑', '单元剧'],
    shortDesc: '每一起案件背后，都藏着一段不愿被提起的往事。',
    synopsis:
      '刑侦队长带领团队侦破一系列看似毫无关联的案件，却逐渐发现它们都指向同一个被遗忘的真相。剧集以单元式叙事层层递进，在紧张的推理中探讨人性深处。',
    uploadDate: '2026-08-02',
    views: '178.3万',
    rating: 8.9,
  },
  {
    id: 'tv004',
    title: '我们的十年',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=heartwarming%20family%20drama%20poster%20warm%20living%20room%20with%20photo%20frames%20and%20soft%20sunlight%20through%20window%2C%20nostalgic%20cinematic%20tone%2C%20cozy%20emotional%20mood%2C%20no%20text&width=800&height=450&seq=tv004cover&orientation=landscape',
    duration: '44:30',
    year: '2025',
    region: '中国大陆',
    genres: ['家庭', '剧情'],
    tags: ['年代', '温情', '群像'],
    shortDesc: '十年光阴，一个普通家庭的悲欢离合与时代变迁。',
    synopsis:
      '从一个南方小城的老弄堂出发，讲述一家三代人跨越十年的生活变迁。剧集用细腻的笔触记录平凡日子里的温情，见证时代的脉搏与家的意义。',
    uploadDate: '2025-10-05',
    views: '142.7万',
    rating: 8.7,
  },
  {
    id: 'tv005',
    title: '医者仁心',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=medical%20drama%20poster%20bright%20modern%20hospital%20corridor%20with%20soft%20daylight%20and%20clean%20minimal%20architecture%2C%20hopeful%20cinematic%20tone%2C%20professional%20atmosphere%2C%20no%20text&width=800&height=450&seq=tv005cover&orientation=landscape',
    duration: '46:10',
    year: '2026',
    region: '中国大陆',
    genres: ['职业', '医疗'],
    tags: ['急诊', '人文', '现实'],
    shortDesc: '在急诊室的每一个深夜，医生们与时间赛跑，也与内心对话。',
    synopsis:
      '聚焦一群急诊科医护人员的日常工作与生活。他们在生死一线间救死扶伤，也在职业理想与现实困境中挣扎。剧集以真实案例为灵感，展现医者的坚守与温度。',
    uploadDate: '2026-05-18',
    views: '133.9万',
    rating: 8.6,
  },
  {
    id: 'tv006',
    title: '学院风云',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=youth%20campus%20drama%20poster%20sunny%20university%20campus%20with%20students%20walking%20among%20green%20trees%20and%20modern%20buildings%2C%20bright%20optimistic%20cinematic%20tone%2C%20fresh%20atmosphere%2C%20no%20text&width=800&height=450&seq=tv006cover&orientation=landscape',
    duration: '40:45',
    year: '2025',
    region: '中国大陆',
    genres: ['青春', '校园'],
    tags: ['社团', '友情', '梦想'],
    shortDesc: '一群怀揣梦想的年轻人，在大学校园里书写属于他们的青春。',
    synopsis:
      '新学期伊始，一群性格各异的年轻人因一个校园项目而聚在一起。他们在碰撞与磨合中建立友谊，在挫折与坚持中靠近梦想。剧集青春洋溢，充满正能量。',
    uploadDate: '2025-09-01',
    views: '118.4万',
    rating: 8.3,
  },
  {
    id: 'ap001',
    title: 'iPhone 17 Pro 首发上手体验',
    type: 'apple',
    appleCategory: '新品',
    cover:
      'https://readdy.ai/api/search-image?query=premium%20tech%20product%20video%20thumbnail%20sleek%20modern%20smartphone%20on%20clean%20minimal%20studio%20surface%20with%20soft%20gradient%20lighting%20and%20gentle%20reflections%2C%20elegant%20editorial%20product%20photography%2C%20no%20text&width=800&height=450&seq=ap001cover&orientation=landscape',
    duration: '18:32',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['新品', '手机', '上手'],
    shortDesc: '第一时间上手全新旗舰，看看这次升级到底值不值得。',
    synopsis:
      '本期视频带来全新一代旗舰机型的第一时间上手体验。从外观设计、屏幕表现到影像系统与性能跑分，我们进行了全方位的实测。视频还将分享真实使用场景下的手感与续航感受，帮助你判断是否值得升级。',
    uploadDate: '2026-09-20',
    views: '89.6万',
    rating: 9.0,
  },
  {
    id: 'ap002',
    title: 'M4 MacBook Air 全面评测',
    type: 'apple',
    appleCategory: '评测',
    cover:
      'https://readdy.ai/api/search-image?query=premium%20tech%20review%20thumbnail%20thin%20silver%20laptop%20open%20on%20minimal%20wooden%20desk%20with%20soft%20natural%20window%20light%2C%20clean%20editorial%20product%20photography%2C%20no%20text&width=800&height=450&seq=ap002cover&orientation=landscape',
    duration: '22:15',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['笔记本', '评测', '性能'],
    shortDesc: '轻薄本的天花板？我们从性能、散热到续航做了深度测试。',
    synopsis:
      '本期评测围绕新一代轻薄笔记本展开。我们测试了视频剪辑、代码编译与多任务处理等重负载场景，并详细对比了不同配置版本的性能差异。同时给出不同预算与需求的选购建议。',
    uploadDate: '2026-08-14',
    views: '67.3万',
    rating: 8.8,
  },
  {
    id: 'ap003',
    title: 'Apple Vision Pro 深度体验',
    type: 'apple',
    appleCategory: '评测',
    cover:
      'https://readdy.ai/api/search-image?query=futuristic%20mixed%20reality%20headset%20on%20clean%20soft%20studio%20background%20with%20calm%20gradient%20and%20subtle%20reflections%2C%20premium%20tech%20editorial%20product%20photography%2C%20no%20text&width=800&height=450&seq=ap003cover&orientation=landscape',
    duration: '26:48',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['空间计算', '头显', '体验'],
    shortDesc: '戴了两周之后，聊聊空间计算设备带来的真实改变。',
    synopsis:
      '在连续使用两周后，我们分享了对空间计算设备的真实感受。从沉浸式观影、办公多屏到日常佩戴舒适度，视频覆盖了工作与娱乐的多个场景，并分析了它在现阶段适合哪些用户。',
    uploadDate: '2026-07-26',
    views: '54.1万',
    rating: 8.6,
  },
  {
    id: 'ap004',
    title: 'AirPods Pro 3 音质升级实测',
    type: 'apple',
    appleCategory: '评测',
    cover:
      'https://readdy.ai/api/search-image?query=premium%20true%20wireless%20earbuds%20in%20charging%20case%20on%20clean%20minimal%20surface%20with%20soft%20studio%20lighting%20and%20gentle%20shadow%2C%20elegant%20product%20photography%2C%20no%20text&width=800&height=450&seq=ap004cover&orientation=landscape',
    duration: '15:20',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['耳机', '降噪', '音质'],
    shortDesc: '降噪与音质双双提升，我们在多种场景下做了对比试听。',
    synopsis:
      '本期视频聚焦新一代无线耳机的音质与降噪表现。我们在通勤、办公与运动等真实场景中进行了对比试听，并测试了通话降噪与空间音频效果，给出是否值得购买的建议。',
    uploadDate: '2026-06-30',
    views: '48.9万',
    rating: 8.5,
  },
  {
    id: 'ap005',
    title: 'Apple Watch Series 11 开箱',
    type: 'apple',
    appleCategory: '新品',
    cover:
      'https://readdy.ai/api/search-image?query=smartwatch%20with%20sport%20band%20on%20clean%20soft%20studio%20background%20with%20gentle%20gradient%20lighting%20and%20subtle%20reflection%2C%20premium%20tech%20editorial%20product%20photography%2C%20no%20text&width=800&height=450&seq=ap005cover&orientation=landscape',
    duration: '12:48',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['手表', '开箱', '健康'],
    shortDesc: '开箱新一代智能手表，看看健康监测带来了哪些新功能。',
    synopsis:
      '本期视频完整开箱新一代智能手表，详细介绍外观、表带与屏幕变化，并上手体验全新升级的健康与运动监测功能。视频还会分享一周续航与佩戴感受。',
    uploadDate: '2026-09-08',
    views: '41.2万',
    rating: 8.4,
  },
  {
    id: 'ap006',
    title: 'iPad Pro 创作实测',
    type: 'apple',
    appleCategory: '评测',
    cover:
      'https://readdy.ai/api/search-image?query=tablet%20with%20stylus%20and%20creative%20drawing%20app%20on%20screen%20on%20clean%20minimal%20desk%20with%20soft%20daylight%2C%20premium%20tech%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=ap006cover&orientation=landscape',
    duration: '19:05',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['平板', '绘画', '创作'],
    shortDesc: '用平板完成一次完整插画创作，手写笔与性能表现如何？',
    synopsis:
      '本期视频用新款平板与手写笔完成一幅完整的数字插画创作，实测绘画延迟、压感表现与色彩精度，同时测试视频剪辑与多图层处理性能，聊聊它能否替代专业创作设备。',
    uploadDate: '2026-05-12',
    views: '37.8万',
    rating: 8.7,
  },
  {
    id: 'ap007',
    title: '秋季发布会全程回顾',
    type: 'apple',
    appleCategory: '新品',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20tech%20event%20stage%20with%20large%20screen%20and%20soft%20spotlights%20on%20dark%20minimal%20auditorium%2C%20premium%20keynote%20atmosphere%20cinematic%20photography%2C%20no%20text&width=800&height=450&seq=ap007cover&orientation=landscape',
    duration: '58:30',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['发布会', '回顾', '新品'],
    shortDesc: '一小时内看完发布会全部重点，新品亮点一次讲清。',
    synopsis:
      '本期视频浓缩回顾整场发布会的全部重点内容。从新品发布、功能演示到价格与发售信息，我们按产品线逐一梳理，并给出每款产品的初步评价与购买建议。',
    uploadDate: '2026-09-12',
    views: '72.5万',
    rating: 8.9,
  },
  {
    id: 'ap008',
    title: '全新系统新功能上手指南',
    type: 'apple',
    appleCategory: '教程',
    cover:
      'https://readdy.ai/api/search-image?query=laptop%20screen%20showing%20clean%20modern%20operating%20system%20interface%20with%20soft%20studio%20lighting%20on%20minimal%20desk%2C%20premium%20tech%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=ap008cover&orientation=landscape',
    duration: '24:12',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['教程', '系统', '技巧'],
    shortDesc: '手把手带你解锁新版系统里最实用的十个小功能。',
    synopsis:
      '本期教程带你逐一体验新版系统中最实用的十项功能更新，涵盖多任务处理、隐私保护、跨设备协同与个性化设置，帮助你快速上手并提升日常使用效率。',
    uploadDate: '2026-08-05',
    views: '33.6万',
    rating: 8.6,
  },
  {
    id: 'ap009',
    title: '手机摄影进阶技巧教学',
    type: 'apple',
    appleCategory: '教程',
    cover:
      'https://readdy.ai/api/search-image?query=person%20holding%20smartphone%20taking%20photo%20of%20city%20skyline%20at%20golden%20hour%2C%20warm%20cinematic%20lighting%2C%20clean%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=ap009cover&orientation=landscape',
    duration: '21:40',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['摄影', '教程', '技巧'],
    shortDesc: '用手机也能拍出大片感，从构图到后期一步步教你。',
    synopsis:
      '本期教学从构图、用光到参数设置，系统讲解如何用手机拍出具有质感的照片。视频还演示了实况照片、人像模式与延时摄影的进阶用法，并分享简单高效的后期修图流程。',
    uploadDate: '2026-04-22',
    views: '29.4万',
    rating: 8.5,
  },
  {
    id: 'ap010',
    title: '智能助手功能上手教程',
    type: 'apple',
    appleCategory: '教程',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20glowing%20digital%20assistant%20interface%20floating%20over%20clean%20dark%20gradient%20background%20with%20soft%20light%20particles%2C%20futuristic%20tech%20visual%2C%20no%20text&width=800&height=450&seq=ap010cover&orientation=landscape',
    duration: '17:55',
    year: '2026',
    region: '美国',
    genres: ['数码'],
    tags: ['AI', '教程', '效率'],
    shortDesc: '把智能助手真正用起来，这些场景和指令你一定要知道。',
    synopsis:
      '本期教程演示智能助手在写作、总结、翻译与日程安排等场景中的实用用法，并分享提升识别准确率的指令技巧，帮助你在日常工作中真正把 AI 用起来。',
    uploadDate: '2026-03-15',
    views: '45.7万',
    rating: 8.8,
  },
];

export const getVideoById = (id: string): Video | undefined =>
  videos.find((item) => item.id === id);

export const movieVideos = videos.filter((item) => item.type === 'movie');
export const tvVideos = videos.filter((item) => item.type === 'tv');
export const appleVideos = videos.filter((item) => item.type === 'apple');

export const typeLabels: Record<VideoType, string> = {
  movie: '电影',
  tv: '电视剧',
  apple: '苹果视频',
};

export const homeFeatured = ['mv001', 'tv001', 'ap001', 'mv005', 'tv003']
  .map((id) => getVideoById(id))
  .filter((item): item is Video => Boolean(item));